import { useNavigate, useParams } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import { useRegularGrid, useRegularGridUpdateMutation } from "src/hooks";
import { useCase } from "src/hooks/useCase";
import * as RegularGridService from "src/hooks/grids";
import { RegularGridForm } from "src/forms/RegularGridForm";
import { Pane } from "src/components/Pane";
import { isReadOnly } from "src/utils/permission.utils";
import { Spacer } from "src/components/Spacer";
import { ButtonDocs } from "src/components/ButtonDocs";
import { Map } from "leaflet";

interface Props {
  map: Map;
}

export function RegularGridPage(props: Props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId = "" } = useParams<{ caseId: string }>();
  const { data: acase } = useCase(caseId);
  const { data: regularGrid } = useRegularGrid(caseId);

  const updateRegularGridMutation = useRegularGridUpdateMutation(caseId);

  /**
   * Functions
   */
  function handleSubmit(values: RegularGridService.RegularGridMutationData) {
    updateRegularGridMutation.mutateAsync(values).then(() => handleClose());
  }

  function handleClose() {
    navigate(`/cases/${caseId}/grid-settings`);
  }

  return render();

  function render() {
    if (!regularGrid || !acase) return null;

    return (
      <>
        {/* <GridSettingsPage map={props.map} /> */}
        <StyledPane>
          <RegularGridForm
            data={regularGrid}
            readOnly={isReadOnly(acase.permissions.updateRegularGrid)}
            isLoading={updateRegularGridMutation.isLoading}
            errors={updateRegularGridMutation.error?.response?.data}
            onSubmit={handleSubmit}
            onClose={handleClose}
          />

          <Spacer />
          <ButtonDocs docsPath="/tutorial/case/case-grid-settings">{t("label.moreInfoAboutGrid")}</ButtonDocs>
        </StyledPane>
      </>
    );
  }
}

const StyledPane = styled(Pane)``;
